import React from 'react';
import { isInWebView } from '../utils/deviceUtils';

function LoadingModal({ customText }) {
  const mt = isInWebView() ? 'mt-0' : 'mt-[64px]';

  return (
    <div className={`fixed inset-0 bg-white z-50 flex items-center justify-center ${mt}`}>
      <div className="flex flex-col items-center">
        {/* Lipstick animation */}
        <div className="w-16 h-16 mb-8">
          <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-black"></div>
        </div>

        {/* Loading text */}
        <div className="text-center">
          <h3 className="text-xl font-medium text-gray-900 mb-2">
            {customText || "Création de votre demande en cours"}
          </h3>
          <p className="text-sm text-gray-500">
            Merci de patienter quelques instants...
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoadingModal;